export const EMAIL_REGEX= /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const PHONE_REGEX= /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
export const START_WITH_HTTP = /^https?:\/\//;
export const AUTH_TYPES = {
    OTP: 'OTP',
    ORDER_NUMBER: 'ORDER_NUMBER',
    ORDER_NUMBER_AND_ZIP_CODE: 'ORDER_NUMBER_AND_ZIP_CODE',
    ORDER_NUMBER_AND_EMAIL: 'ORDER_NUMBER_AND_EMAIL',
}

